(function($) {

  var esCollectionRuntime = window.__ES_COLLECTION_RUNTIME__ = window.__ES_COLLECTION_RUNTIME__ || {
    popstateBound: false,
    filterXhr: null,
    filterReqId: 0,
    activeFilterReqId: 0,
    pagehideBound: false
  };

  function bindCollectionPagehideCleanup() {
    if (esCollectionRuntime.pagehideBound) return;
    esCollectionRuntime.pagehideBound = true;
    window.addEventListener('pagehide', function() {
      try {
        if (esCollectionRuntime.filterXhr && esCollectionRuntime.filterXhr.readyState !== 4) {
          esCollectionRuntime.filterXhr.abort();
        }
      } catch (e) {}
      esCollectionRuntime.filterXhr = null;
      esCollectionRuntime.activeFilterReqId = 0;
      closeFilterOverlayState();
    });
  }


  function closeFilterOverlayState() {
    try {
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active');
    } catch (e) {}
  }

  function bindCollectionPopstate() {
    if (esCollectionRuntime.popstateBound) return;
    esCollectionRuntime.popstateBound = true;
    window.addEventListener('popstate', function() {
      if (!$('.engoj-collection-sidebar').length) return;
      collection.filterParams();
      var newurl = collection.filterCreateUrl();
      collection.filterGetContent(newurl);
      collection.resetFilter();
    });
  }

  $(document).ready(function() {
    bindCollectionPagehideCleanup();
    bindCollectionPopstate();
    collection.init();
  });

  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

	  /* Collection Sorting */
      this.initCollectionSorting();

    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {

    },

    fillterTagEvents: function() {

      $('body').off('click.esCollectionFilterTag', '.filter-tag a:not(".clear"), .filter-tag label').on('click.esCollectionFilterTag', '.filter-tag a:not(".clear"), .filter-tag label', function(e) {
         $(this).toggleClass('active');
        var currentTags = [];

        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
            } else {
                currentTags.push(tagName);
            }
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
        $('body').off('click.esCollectionClearAll', '.refined-widgets a.clear-all').on('click.esCollectionClearAll', '.refined-widgets a.clear-all', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
          	$('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
          	
        });

         $('body').off('click.esCollectionBlockClear', '.filter-block .clear').on('click.esCollectionBlockClear', '.filter-block .clear', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active");
              });
              if (currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });

    },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
    
    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        var $clear = filterTag.find(".clear");
        if (!$clear.length) return;
        if (filterTag.find("input:checked").length > 0) {
          $clear.show();
        } else {
          $clear.hide();
        }
        $clear.off('click.esCollectionInlineClear').on('click.esCollectionInlineClear', function(e) {
          var currentTags = [];
          if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
          }
          filterTag.find("input:checked").each(function() {
            var selectedTag = $(this);
            var tagName = selectedTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
              }
            }
          });
          if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
          } else {
            delete Shopify.queryParams.constraint;
          }
          collection.filterAjaxClick();
          e.preventDefault();
        });
      });
    }, 
    

    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
    },

    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        $(".filter-tag input:checked").attr("checked", false);

        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },

    filterMapData: function(data) {

        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");

        currentList.replaceWith(productList);

        // Eyeshells: keep user-selected collection grid columns across AJAX updates
        try { if (window.ES_applyCollectionCols) { window.ES_applyCollectionCols(); } } catch(e) {}


        /* -----------------------------------------------------
          Eyeshells FIX (V12): Results count line not updating after AJAX filters

          Replace the results-count blocks from the AJAX response.
          This is the most reliable approach across different collection layouts.
        ------------------------------------------------------ */
        (function updateShowingCountFromResponse() {
          try {
            var $resp = $(data);

            var $respDesktopCount = $resp.find('.es-desktop-results-count').first();
            var $respMobileCount  = $resp.find('.es-mobile-results-count').first();
            var $respLegacyCount  = $resp.find('.results-count').first();

            if ($respDesktopCount.length && $('.es-desktop-results-count').length) {
              $('.es-desktop-results-count').each(function() {
                $(this).replaceWith($respDesktopCount.clone(true, true));
              });
            }

            if ($respMobileCount.length && $('.es-mobile-results-count').length) {
              $('.es-mobile-results-count').each(function() {
                $(this).replaceWith($respMobileCount.clone(true, true));
              });
            }

            if ($respLegacyCount.length && $('.results-count').length) {
              $('.results-count').each(function() {
                $(this).replaceWith($respLegacyCount.clone(true, true));
              });
            }

            // Toolbar fallback
            var $newDesktopToolbar = $resp.find('.shop_control .filter_sortby.d-none.d-lg-block').first();
            var $curDesktopToolbar = $('.shop_control .filter_sortby.d-none.d-lg-block').first();
            if ($newDesktopToolbar.length && $curDesktopToolbar.length) {
              $curDesktopToolbar.replaceWith($newDesktopToolbar);
            }

            var $newMobileToolbar = $resp.find('.shop_control .filter_sortby.d-flex.d-lg-none').first();
            var $curMobileToolbar = $('.shop_control .filter_sortby.d-flex.d-lg-none').first();
            if ($newMobileToolbar.length && $curMobileToolbar.length) {
              $curMobileToolbar.replaceWith($newMobileToolbar);
            }

            var $newMobileLine = $resp.find('.es-mobile-results-count').first();
            var $curMobileLine = $('.es-mobile-results-count').first();
            if ($newMobileLine.length && $curMobileLine.length) {
              $curMobileLine.replaceWith($newMobileLine);
            }
          } catch (e) {}
        })();

        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();

        // Eyeshells mobile safety: quickview.js is intentionally desktop-lazy-loaded.
        // Calling quickView() unguarded after a mobile sort/filter AJAX refresh throws,
        // which can leave the global loading popup stuck on screen.
        if (typeof window.quickView === 'function') {
          window.quickView();
        }
      

        // Swatch image switching is handled globally in assets/es-swatch.js (Custom: main + secondary image).

    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      // Native pushState does NOT trigger popstate, so no extra guard flag is needed.
      try {
        history.pushState({ param: Shopify.queryParams }, '', newurl);
      } catch (e) {
        // If pushState fails for any reason, fall back to updating the URL directly.
        window.location.href = newurl;
        return;
      }
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {

      var reqId = ++esCollectionRuntime.filterReqId;
      esCollectionRuntime.activeFilterReqId = reqId;
      try {
        if (esCollectionRuntime.filterXhr && esCollectionRuntime.filterXhr.readyState !== 4) {
          esCollectionRuntime.filterXhr.abort();
        }
      } catch (e) {}

      esCollectionRuntime.filterXhr = $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          closeFilterOverlayState();
          showPopup('.loading');
        },

        success: function(data) {
          if (reqId !== esCollectionRuntime.activeFilterReqId) return;

          try {
            collection.filterMapData(data);
            collection.filterMapClear();
          } catch (err) {
            try {
              if (window.console && console.warn) {
                console.warn('Eyeshells collection AJAX refresh failed; loading state cleared safely.', err);
              }
            } catch (e) {}
          } finally {
            hidePopup('.loading');
            closeFilterOverlayState();
            hidePopup('.filter-to-left , .js-bg');
          }
		  
        },

        error: function(xhr, text) {
          if (text === 'abort') return;
          if (reqId !== esCollectionRuntime.activeFilterReqId) return;
          hidePopup('.loading');
          closeFilterOverlayState();
          hidePopup('.filter-to-left, .js-bg');
          try {
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          } catch (e) {
            $('.ajax-error-message').text('Something went wrong. Please try again.');
          }
          showPopup('.ajax-error-modal');
        },

        complete: function() {
          closeFilterOverlayState();
          if (reqId === esCollectionRuntime.activeFilterReqId) {
            esCollectionRuntime.filterXhr = null;
            try { hidePopup('.loading'); } catch (e) {}
          }
        }

      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();

      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(document).off('click.esCollectionSorting', '.collection-sorting a').on('click.esCollectionSorting', '.collection-sorting a', function(e) {
        e.preventDefault();

        var $link = $(this);
        var sortValue = $link.attr("href");
        if (!sortValue) return;

        if (!$link.parent().hasClass("active")) {
          Shopify.queryParams.sort_by = sortValue;
          collection.filterAjaxClick();
        }

        var $dropdown = $link.closest('.dropdown');
        var selected = $.trim($link.find('.sort-text').first().text() || $link.text());

        $dropdown.find('.sort-item').removeClass("active");
        $dropdown.find('.sort-item > a[href="' + sortValue + '"]').each(function(){
          $(this).parent().addClass("active");
          $(this).attr('aria-checked', 'true');
        });
        $dropdown.find('.sort-item > a').not('[href="' + sortValue + '"]').attr('aria-checked', 'false');

        if (selected) {
          $dropdown.find('.dropdown-label').text(selected);
        }
        $dropdown.find('.dropdown-content').removeClass('active');
      });
    }
,

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);


(function () {
  if (window.__esCardHoverIntentCleanup) {
    try { window.__esCardHoverIntentCleanup(); } catch (e) {}
  }

  function initCollectionCardHoverIntent() {
    if (!document.body) return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)').matches) return;

    var scopes = [];
    if (document.body.classList.contains('template-collection')) scopes.push('body.template-collection');
    if (document.body.classList.contains('template-search')) scopes.push('body.template-search');
    if (document.body.classList.contains('template-index')) scopes.push('body.template-index');
    if (!scopes.length) return;

    var SELECTOR = scopes.map(function(scope) {
      return scope + ' .product-item-v1 .es-card-media-desktop > .engo-hover-swap, ' + scope + ' .product-item-v1 .es-card-media-desktop > .engoj_find_img';
    }).join(', ');
    var HOVER_DELAY = 200;
    var WHEEL_GUARD = 120;
    var lastWheelAt = 0;
    var timers = new WeakMap();

    function clearTimer(el) {
      var timer = timers.get(el);
      if (timer) {
        clearTimeout(timer);
        timers.delete(el);
      }
    }

    function clearAllActive() {
      document.querySelectorAll(scopes.map(function(scope){ return scope + ' .is-deliberate-hover'; }).join(', ')).forEach(function(el) {
        el.classList.remove('is-deliberate-hover');
      });
    }

    function onWheel() {
      lastWheelAt = Date.now();
      clearAllActive();
    }

    function onMouseOver(e) {
      var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
      if (!el) return;
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      if (Date.now() - lastWheelAt < WHEEL_GUARD) return;

      clearTimer(el);
      var timer = setTimeout(function() {
        if (!el.matches(':hover')) return;
        if (Date.now() - lastWheelAt < WHEEL_GUARD) return;
        el.classList.add('is-deliberate-hover');
      }, HOVER_DELAY);

      timers.set(el, timer);
    }

    function onMouseOut(e) {
      var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
      if (!el) return;
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      clearTimer(el);
      el.classList.remove('is-deliberate-hover');
    }

    document.addEventListener('wheel', onWheel, { passive: true });
    document.addEventListener('mouseover', onMouseOver, true);
    document.addEventListener('mouseout', onMouseOut, true);

    window.__esCardHoverIntentCleanup = function () {
      document.removeEventListener('wheel', onWheel, { passive: true });
      document.removeEventListener('mouseover', onMouseOver, true);
      document.removeEventListener('mouseout', onMouseOut, true);
      clearAllActive();
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionCardHoverIntent, { once: true });
  } else {
    initCollectionCardHoverIntent();
  }
})();;


/* 1089: Only allow collection hover image swap after the secondary image is ready. */
(function () {
  if (window.__esSafeCollectionHoverSwapCleanup) {
    try { window.__esSafeCollectionHoverSwapCleanup(); } catch (e) {}
  }

  var MQ = '(min-width: 992px) and (hover: hover) and (pointer: fine)';
  var WRAP_SELECTOR = 'body.template-collection .product-item-v1 .es-card-media-desktop > .engo-hover-swap, body.template-search .product-item-v1 .es-card-media-desktop > .engo-hover-swap';
  var SECONDARY_SELECTOR = 'img.engo-secondary-image';
  var listeners = [];
  var observer = null;

  function eligible() {
    return !!(document.body && window.matchMedia && window.matchMedia(MQ).matches && (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')));
  }

  function isReady(img) {
    return !!(img && img.complete && img.naturalWidth && img.naturalWidth > 1);
  }

  function setReady(img) {
    var wrap = img && img.closest ? img.closest('.engo-hover-swap') : null;
    if (!wrap) return;
    if (isReady(img)) {
      wrap.classList.add('es-hover-ready');
    } else {
      wrap.classList.remove('es-hover-ready');
    }
  }

  function bindSecondary(img) {
    if (!img || img.__esHoverReadyBound) return;
    img.__esHoverReadyBound = true;
    img.addEventListener('load', function () { setReady(img); }, { passive: true });
    img.addEventListener('error', function () {
      var wrap = img.closest && img.closest('.engo-hover-swap');
      if (wrap) wrap.classList.remove('es-hover-ready');
    }, { passive: true });
    setReady(img);
  }

  function bindWithin(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(WRAP_SELECTOR + ' > ' + SECONDARY_SELECTOR).forEach(bindSecondary);
  }

  function prepareWrap(wrap) {
    if (!wrap) return;
    var img = wrap.querySelector(SECONDARY_SELECTOR);
    if (!img) {
      wrap.classList.remove('es-hover-ready');
      return;
    }
    bindSecondary(img);
    if (isReady(img)) {
      wrap.classList.add('es-hover-ready');
      return;
    }

    wrap.classList.remove('es-hover-ready');

    try { img.loading = 'eager'; } catch (e) {}
    try { img.fetchPriority = 'auto'; } catch (e) {}

    if (img.decode) {
      img.decode().then(function () { setReady(img); }).catch(function () { setReady(img); });
    }
  }

  function onPointerOver(e) {
    if (!eligible()) return;
    var wrap = e.target && e.target.closest ? e.target.closest(WRAP_SELECTOR) : null;
    if (!wrap) return;
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    prepareWrap(wrap);
  }

  function onPointerOut(e) {
    var wrap = e.target && e.target.closest ? e.target.closest(WRAP_SELECTOR) : null;
    if (!wrap) return;
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    wrap.classList.remove('is-deliberate-hover');
  }

  function onMutations(mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        var img = mutation.target;
        if (img && img.matches && img.matches(SECONDARY_SELECTOR)) {
          var wrap = img.closest && img.closest('.engo-hover-swap');
          if (wrap) wrap.classList.remove('es-hover-ready');
          bindSecondary(img);
          setReady(img);
        }
      } else if (mutation.type === 'childList') {
        mutation.addedNodes && Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(SECONDARY_SELECTOR)) bindSecondary(node);
          bindWithin(node);
        });
      }
    });
  }

  function init() {
    bindWithin(document);
    document.addEventListener('mouseover', onPointerOver, true);
    document.addEventListener('mouseout', onPointerOut, true);
    listeners.push(['mouseover', onPointerOver], ['mouseout', onPointerOut]);

    if (window.MutationObserver && document.documentElement) {
      observer = new MutationObserver(onMutations);
      observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.__esSafeCollectionHoverSwapCleanup = function () {
    listeners.forEach(function (entry) { document.removeEventListener(entry[0], entry[1], true); });
    listeners = [];
    if (observer) observer.disconnect();
    observer = null;
    document.querySelectorAll('.engo-hover-swap.es-hover-ready').forEach(function (wrap) {
      wrap.classList.remove('es-hover-ready');
    });
  };
})();


/* 1090: warm nearby collection hover images so the safe hover guard still feels instant. */
(function () {
  if (window.__esHoverImageWarmupCleanup) {
    try { window.__esHoverImageWarmupCleanup(); } catch (e) {}
  }

  var MQ = '(min-width: 992px) and (hover: hover) and (pointer: fine)';
  var SELECTOR = 'body.template-collection .product-item-v1 .es-card-media-desktop > .engo-hover-swap > img.engo-secondary-image, body.template-search .product-item-v1 .es-card-media-desktop > .engo-hover-swap > img.engo-secondary-image';
  var io = null;
  var timers = [];

  function active() {
    return !!(document.body && window.matchMedia && window.matchMedia(MQ).matches && (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')));
  }

  function markReady(img) {
    if (!img) return;
    var wrap = img.closest && img.closest('.engo-hover-swap');
    if (!wrap) return;
    if (img.complete && img.naturalWidth > 1) wrap.classList.add('es-hover-ready');
  }

  function warm(img, priority) {
    if (!img || img.__esHoverWarmStarted) {
      markReady(img);
      return;
    }
    img.__esHoverWarmStarted = true;

    try { img.loading = 'eager'; } catch (e) {}
    try { img.fetchPriority = priority || 'low'; } catch (e) {}

    if (img.complete && img.naturalWidth > 1) {
      markReady(img);
      return;
    }

    var pre = new Image();
    if (img.sizes) pre.sizes = img.sizes;
    if (img.srcset) pre.srcset = img.srcset;
    pre.onload = function () { markReady(img); };
    pre.onerror = function () { markReady(img); };
    pre.src = img.currentSrc || img.src;
  }

  function getImages() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function init() {
    if (!active()) return;
    var imgs = getImages();
    if (!imgs.length) return;

    // First screen / near-first-screen cards should feel like the old immediate hover.
    imgs.slice(0, 18).forEach(function (img, index) {
      warm(img, index < 8 ? 'auto' : 'low');
    });

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var img = entry.target;
          warm(img, 'low');
          try { io.unobserve(img); } catch (e) {}
        });
      }, { rootMargin: '900px 0px' });
      imgs.forEach(function (img) { try { io.observe(img); } catch (e) {} });
    } else {
      var t = setTimeout(function () { getImages().slice(0, 36).forEach(function (img) { warm(img, 'low'); }); }, 500);
      timers.push(t);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    var t = setTimeout(init, 0);
    timers.push(t);
  }

  window.__esHoverImageWarmupCleanup = function () {
    if (io) io.disconnect();
    io = null;
    timers.forEach(function (t) { clearTimeout(t); });
    timers = [];
  };
})();
